import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from './useAccount';

/**
 * Moeda de OPERAÇÃO da conta (funil/negócios do cliente) — vem de
 * `account.currency` (Account#operating_currency no backend). Separada do nosso
 * billing. Fonte única de formatação de dinheiro do CRM.
 * @returns {{ currency: import('vue').ComputedRef<string>, formatCurrency: Function }}
 */
export function useCurrency() {
  const { currentAccount } = useAccount();
  const { locale } = useI18n();

  const currency = computed(() => currentAccount.value?.currency || 'BRL');
  const browserLocale = computed(() => locale.value.replace('_', '-'));

  // Símbolo da moeda (R$, €, $…) pra formatos compactos (1,2M) onde o Intl full
  // não cabe.
  const currencySymbol = computed(() => {
    try {
      const parts = new Intl.NumberFormat(browserLocale.value, {
        style: 'currency',
        currency: currency.value,
      }).formatToParts(0);
      return parts.find(p => p.type === 'currency')?.value || currency.value;
    } catch (e) {
      return currency.value;
    }
  });

  const formatCurrency = (value, currencyCode) =>
    new Intl.NumberFormat(browserLocale.value, {
      style: 'currency',
      currency: currencyCode || currency.value,
    }).format(value || 0);

  return { currency, currencySymbol, formatCurrency };
}
